export enum CustomerTypeEnum {
  consumer = 'consumer',
  business = 'business',
}

export interface CustomerTypeSelectionFormStateModel {
  customerType: CustomerTypeEnum | null;
}
